import Checkpoint from "models/checkpoint";
import { useTranslation } from "react-i18next";
import { Loader } from "semantic-ui-react";
import PropTypes from "prop-types";
import React from "react";
import classes from "./checkpointStats.module.scss";

const AttendeeInCheckpoint = ({ checkpoint }) => {
	const { t } = useTranslation();

	// Statistics memoization
	const stats = React.useMemo(() => checkpoint.getStatistics(), [checkpoint]);

	// Main display memoization
	const mainDisplay = React.useMemo(() => {
		if (!stats) {
			return 0 / 0;
		}
		return `${stats._scan_in} / ${stats._attendee_count}`;
	}, [stats]);
	// Memoization of conditional sub-display
	const insideCountDisplay = React.useMemo(() => {
		if (!stats || stats._scan_out === 0) return "";
		return `${t("access.checkpoint.attendeeincludingLabel")} ${
			stats._inside_count
		} ${t("access.checkpoint.attendeeInLabel")}`;
	}, [stats, t]);

	// Check data before use of stats
	if (!stats || stats.expiredData()) {
		return <Loader active size="mini" inline />;
	}

	return (
		<div>
			<div>{mainDisplay}</div>
			{insideCountDisplay && (
				<div className={classes.insideCountDisplay}>
					{insideCountDisplay}
				</div>
			)}
		</div>
	);
};

AttendeeInCheckpoint.propTypes = {
	checkpoint: PropTypes.instanceOf(Checkpoint).isRequired
};

export default AttendeeInCheckpoint;
